import { Component, Host, h, Prop } from '@stencil/core';

export type CardVariant = 'big' | 'small' | 'nopadding';

@Component({
  tag: 'uui-card',
  styleUrl: 'uui-card.css',
  shadow: true
})

/**
 * @slot default - Slot for the content of the uui-card.
 */
export class UuiCard {
  /** width of a card */
  @Prop() width: string = 'auto';
  @Prop() height: string;
  /** type of card - changes the padding applied */
  @Prop() variant: CardVariant = 'small';

  render() {
    const { width, height, variant } = this;

    return (
      <Host>
        <article style={{ width, height }} data-mode={variant}>
          <slot />
        </article>
      </Host>
    );
  }
}
